/** Keeps source page sizes and graphics while joining PDFs in file-selection order. */
export async function mergePdfImportFiles(
  files: readonly File[],
  signal: AbortSignal,
  onProgress?: (completed: number, total: number, fileName: string) => void,
  onSourcePages?: (index: number, pageCount: number) => void,
): Promise<File> {
  const checkAbort = () => {
    if (signal.aborted) throw new DOMException("Abgebrochen", "AbortError");
  };
  checkAbort();
  if (!files.length) throw new Error("Bitte mindestens eine PDF-Datei auswählen.");
  if (files.length === 1) return files[0];
  const { PDFDocument } = await import("pdf-lib");
  const merged = await PDFDocument.create();
  for (const [index, file] of files.entries()) {
    checkAbort();
    onProgress?.(index, files.length, file.name);
    try {
      const bytes = await file.arrayBuffer();
      checkAbort();
      const source = await PDFDocument.load(bytes);
      onSourcePages?.(index, source.getPageCount());
      checkAbort();
      const pages = await merged.copyPages(source, source.getPageIndices());
      checkAbort();
      for (const page of pages) merged.addPage(page);
    } catch (error) {
      checkAbort();
      throw new Error(file.name + ": " + (error instanceof Error ? error.message : String(error)));
    }
    onProgress?.(index + 1, files.length, file.name);
  }
  const bytes = await merged.save();
  checkAbort();
  const name = files[0].name.replace(/\.pdf$/i, "") + "_gesamt.pdf";
  return new File([Uint8Array.from(bytes)], name, { type: "application/pdf" });
}
